export class ApiFailure extends Error { constructor(public status: number, message: string) { super(message); } }

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, { credentials: "include", ...init, headers: { "Content-Type": "application/json", ...init?.headers } });
  const payload = await response.json().catch(() => ({ error: "Сервер не ответил" })) as { error?: string };
  if (!response.ok) throw new ApiFailure(response.status, payload.error ?? "Ошибка запроса");
  return payload as T;
}

export function post<T>(path: string, body: unknown): Promise<T> { return api<T>(path, { method: "POST", body: JSON.stringify(body) }); }
export function commandKey(): string { return crypto.randomUUID(); }
